export const populationForecastSQL = ( table) => {

    const query =  `/* PF - Select data for total population forecast */
    SELECT * from (
    (SELECT geo_type,geo_name, year, population, round( sum (value)) as total
    FROM prime_brisbane_${table}
    GROUP BY geo_type,geo_name, population, year)

    UNION

    (SELECT geo_type,geo_name, year, 'Persons' as population, round(sum(value)) as total 
    FROM prime_brisbane_${table}
    GROUP BY geo_type,geo_name, year)) as subq 
    
    ORDER BY year ASC` 
    //console.log('populationForecastSQL', query);
    return query;
  }
export const householdQuery = (table) => {
  const query = `/* PF - Select data for number of households */
  SELECT geo_type, geo_name, year, population, category, (value) as total
  FROM prime_brisbane_${table}
  WHERE index NOT IN (0,1,7)
  order by year ASC, index`;
        //console.log('query', query);
        return query;
}

export const averageHouseholdQuery = (table) => {
  const query = `/* PF - Select data for average households size */
  SELECT geo_type, geo_name, year, population, category, (value) as total
  FROM prime_brisbane_${table}
  order by year ASC, index`;
        //console.log('query', query);
        return query;
}
export const populationForecastPyramidSQL = (year, table) => {
  const query = `/* PF - Select data for age servive group and five years cohorts to make pyramid chart */
  SELECT * FROM (
  (SELECT geo_type,geo_name, year, population, round(sum (value)) as total, category, index
  FROM brisbane.prime_brisbane_${table}
  WHERE year = ${year}
  GROUP BY geo_type, geo_name, year, population, category, index)
  
  UNION
  
  (SELECT geo_type,geo_name, year, 'Persons' as population, round(sum(value)) as total, category, index
  FROM brisbane.prime_brisbane_${table}
  WHERE year = ${year}
  GROUP BY geo_type, geo_name, year, category, index)) as subq

  ORDER BY index ASC`
      //console.log('query', query);
      return query;
}




// WEBPACK FOOTER //
// ./src/sql/populationForecastQueries.js